import dayjs from 'dayjs';

export const filterBuilder = (filter) => {
  const dateFormat = 'YYYY-MM-DD';
  const [startDate, endDate] = filter.registrationDate;

  const result = {
    ...filter,
    startDate: dayjs(startDate).format(dateFormat),
    endDate: dayjs(endDate).format(dateFormat),
    statusDate: dayjs(filter.statusDate).format(dateFormat),
  };

  delete result['registrationDate'];

  return result;
};

export const rebuildDatesFilter = (query) => {
  const { startDate, endDate } = query;
  const registrationDate = [
    dayjs(startDate).toDate(),
    dayjs(endDate).toDate(),
  ];
  return { ...query, registrationDate };
};


export const rebuildCities = (dataCities) => {
  const data = dataCities.map(city => ({
    value: JSON.stringify([city.value]),
    label: city.label
  }));
  return data;
};

export const replaceCity = (city) => {
  return city.replace(/[^\w\d-]/gi, '');
};
